var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 322,
    viewBox: "0 0 296 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 28.6938C196.576 -29.9664 250.744 14.7271 271.98 44.4063L296 298.949L182.164 315.71C168.587 318.852 129.11 324.299 79.8157 320.947C30.5215 317.595 23.0716 274.159 25.5085 252.859C34.5597 239.591 45.7693 197.551 18.198 135.539C-26.9188 58.4428 22.3754 37.7721 52.6621 37.0738C65.5427 58.7222 103.001 87.3539 149.788 28.6938Z",
    fill: "#C9DDF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/Blob-3.6dab6ea481ed4ff834b0e2bc2ffe486d.svg";
export { ForwardRef as ReactComponent };